/** Бренд VIA DOMUM (затверджено 16.10.2026). Перевизначається через VITE_BRAND_NAME. */
export const BRAND_NAME: string = (import.meta.env.VITE_BRAND_NAME as string | undefined) || 'VIA DOMUM';
export const BRAND_SUFFIX = 'CRM';

export const API_URL: string = (
  (import.meta.env.VITE_API_URL as string | undefined) || 'http://localhost:8000'
).replace(/\/+$/, '');

/** Мета продажу за замовчуванням (сервер повертає фактичну в /dashboard). */
export const DEFAULT_SALES_TARGET = 1100;

/** Інтервал поллінгу інбоксу, мс. */
export const INBOX_POLL_MS = 5000;

export const CONTENT_LOCALES = ['uk', 'en', 'pl', 'ro'] as const;
export type ContentLocale = (typeof CONTENT_LOCALES)[number];
